import { ComponentLocatorMap } from '../types/ComponentLocatorMap';

export const alertComponent = {
  closeButton: 'alert.close-button',
} as const satisfies ComponentLocatorMap;
